/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StopChargeTask
 */
export interface StopChargeTask {
    /**
     *
     * @type {number}
     * @memberof StopChargeTask
     */
    connectorIndex?: number;
    /**
     *
     * @type {number}
     * @memberof StopChargeTask
     */
    transactionId?: number;
    /**
     *
     * @type {boolean}
     * @memberof StopChargeTask
     */
    forceStop?: boolean;
}

/**
 * Check if a given object implements the StopChargeTask interface.
 */
export function instanceOfStopChargeTask(
    value: object,
): value is StopChargeTask {
    return true;
}

export function StopChargeTaskFromJSON(json: any): StopChargeTask {
    return StopChargeTaskFromJSONTyped(json, false);
}

export function StopChargeTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): StopChargeTask {
    if (json == null) {
        return json;
    }
    return {
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        transactionId:
            json["transactionId"] == null ? undefined : json["transactionId"],
        forceStop: json["forceStop"] == null ? undefined : json["forceStop"],
    };
}

export function StopChargeTaskToJSON(value?: StopChargeTask | null): any {
    if (value == null) {
        return value;
    }
    return {
        connectorIndex: value["connectorIndex"],
        transactionId: value["transactionId"],
        forceStop: value["forceStop"],
    };
}
